import React, { useState, useEffect, useCallback } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Creature, CreatureLimitation,
} from "@dndModels";
import { 
  DisablableOption 
} from "@models";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
import DandDCharacterUtilities from '@dndUtilities/char_utilities';

import LoadingBox from "@components/input/LoadingBox";
import FilterBox from "@dndComponents/filtering/FilterBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";

interface Props {
  name: string;
  value?: string;
  values?: string[];
  multiple?: boolean;
  max_selected?: number;
  onChange?: Function | null;
  onChangeObject?: Function | null; 
  disabled?: boolean;
  limit?: CreatureLimitation;
  filter?: any;
}

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function SelectCreatureBox({
  name,
  value = "",
  values = [],
  multiple = false,
  max_selected = -1,
  disabled = false,
  onChange = null,
  onChangeObject = null,
  limit,
  filter: props_filter = {}
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [creatures, setCreatures] = useState<Creature[]>([]);
  const [reloading, setReloading] = useState(false);
  const [true_filter, setTrueFilter] = useState<any>({});
  const [filter, setFilter] = useState<any>({ search_string: [""] });
  // const [search_string, setSearchString] = useState("");
  // const [my_level, setLevel] = useState("Any");
  // const [school, setSchool] = useState("Any");

  const load = useCallback( async () => {
    setLoading(true);
    const res = await api.getSetOfObjects({ data_types: ["creature"]});
    // debugger;
    const the_creatures = res.creature as Creature[];
    const creature_finder = the_creatures.find(o => o._id === value);
    setCreatures(the_creatures);
    if (creature_finder) {
      // setSearchString(creature_finder.name);
      setFilter({...filter,"$or": [{ "name*includes": creature_finder.name },{ "description*includes": creature_finder.name }]});
      setTrueFilter({...true_filter,"$or": [{ "name*includes": creature_finder.name },{ "description*includes": creature_finder.name }]});
      setReloading(true);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched, load]);

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading]);

  const updateFilter = (changed: any) => {
    // debugger;
    // "source_book","school","creature_level","effect_type","attack_type"
    const new_filter = {...changed};
    // const the_search_string = new_filter.search_string ? new_filter.search_string[0] : "";
    // if (the_search_string !== "") {
    //   new_filter["$or"] = [{ "name*includes": the_search_string }, { "description*includes": the_search_string }];
    // }
    // delete new_filter.search_string;

    setTrueFilter(new_filter);
    setReloading(true);
  }

  const translateFilterFromBox = (the_filter: any) => {
    const new_filter = {...the_filter};
    
    if (!new_filter.search_string || new_filter.search_string.length === 0) {
      delete new_filter.search_string;
    }
    if (new_filter.source_book) {
      new_filter.source_book_ids = new_filter.source_book;
      delete new_filter.source_book;
    }
    if (new_filter.effect_type) {
      new_filter.the_effect_types = new_filter.effect_type;
      delete new_filter.effect_type;
    }
    if (new_filter.attack_type) {
      new_filter.the_attack_types = new_filter.attack_type;
      delete new_filter.attack_type;
    }
    const min_cr = new_filter.min_cr;
    const max_cr = new_filter.max_cr;
    if (min_cr !== undefined || max_cr !== undefined) {
      new_filter.challenge_rating = {};
      if (min_cr !== undefined) {
        new_filter.challenge_rating["$gte"] = min_cr;
      }
      if (max_cr !== undefined) {
        new_filter.challenge_rating["$lte"] = max_cr;
      }
      delete new_filter.min_cr;
      delete new_filter.max_cr;
    }
    const creature_size = new_filter.creature_size;
    if (creature_size !== undefined) {
      delete new_filter.creature_size;
      if (creature_size.in) {
        new_filter.size_num = { in: creature_size.in.map((o: string) => +o) };
      } else if (creature_size.nin) {
        new_filter.size_num = { nin: creature_size.nin.map((o: string) => +o) };
      }
    }
    // console.log(new_filter);
    return new_filter;
  }

  const get_filtered = () => {
    let filtered = [...creatures];

    const use_filter = {...translateFilterFromBox(true_filter),...props_filter};

    // debugger;
    filtered = api.filter("creature", filtered, use_filter) as Creature[];
    if (limit) {
      if (limit.creature_ids.length > 0) {
        filtered = filtered.filter(o => limit.creature_ids.includes(o._id));
      }
      if (!limit.allow_flight) {
        filtered = filtered.filter(o => !o.flying);
      }
      if (!limit.allow_swimming) {
        filtered = filtered.filter(o => !o.swimming);
      }
      if (limit.creature_types.length > 0) {
        filtered = filtered.filter(o => limit.creature_types.includes(o.creature_type));
      }
      if (limit.subtypes.length > 0) {
        filtered = filtered.filter(o => common_util.anyOverlaps(limit.subtypes, o.subtypes));
      }
      if (limit.size_nums.length > 0) {
        filtered = filtered.filter(o => limit.size_nums.includes(o.size_num));
      }
      if (limit.min_challenge_rating > -1) {
        filtered = filtered.filter(o => limit.min_challenge_rating <= o.challenge_rating);
      }
      if (limit.max_challenge_rating > -1) {
        filtered = filtered.filter(o => limit.max_challenge_rating >= o.challenge_rating);
      }
    }
    const string_limit = 50;
    const sorted = filtered.sort((a, b) => {
      // if (["Brontosaurus","Giant Ape"].includes(a.name) && ["Brontosaurus","Giant Ape"].includes(b.name)) {
      //   debugger;
      // }
      if (a.challenge_rating === b.challenge_rating) {
        return a.name.localeCompare(b.name);
      } else {
        return a.challenge_rating > b.challenge_rating ? 1 : -1;
      }
    }).map(o => {
      let text = char_util.getStringWithReplacementsWithObject({ clean_me: "{obj.true_name} (CR: {obj.challenge_rating}){obj.flying_string}", backup: "{obj.true_name}", obj: o });
      if (text.length > string_limit) {
        text = text.substring(0, string_limit) + "...";
      }
      const option: DisablableOption = {
        id: o._id, text
      };
      return option;
    });
    return sorted;
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else {
    const filtered = get_filtered();
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <FilterBox 
            data_type="creature"
            flat
            dont_use_api
            all_objects={creatures}
            the_filter={filter}
            onChange={updateFilter}
          />
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          { reloading ?
            (<LoadingBox />)
          : filtered.length > 100 ?
            <span>Too many creatures ({ filtered.length })</span>
          : multiple ?
            <SelectObjectBox 
              name={name}
              extra_options={filtered}
              values={values} 
              multiple
              // ignore_missing
              disabled={disabled}
              auto_sort={false}
              max_selected={max_selected}
              // renderValues={ renderValues() }
              // log_it
              // display_format="{obj.true_name} (CR: {obj.challenge_rating}){obj.flying_string}"
              onChange={(changed: string[]) => {
                const objFinder = creatures.filter(o => changed.includes(o._id));
                if (onChange) {
                  onChange(objFinder.map(o => o._id));
                }
                if (onChangeObject) {
                  onChangeObject(objFinder);
                }
              }}
            />
          :
            <SelectObjectBox  
              name={name}
              extra_options={filtered}
              value={value}
              disabled={disabled}
              auto_sort={false}
              // display_format="{obj.true_name} (CR: {obj.challenge_rating}){obj.flying_string}"
              onChange={(id: string) => {
                const objFinder = creatures.find(o => o._id === id);
                if (objFinder) {
                  if (onChange) {
                    onChange(objFinder._id);
                  }
                  if (onChangeObject) {
                    onChangeObject(objFinder);
                  }
                }
              }}
            />
          }
        </Grid>
      </Grid>
    );
  }
}
